import { useState, useEffect } from "react";
const useCurrentUser = (env = "production") => {
  const [user, setUser] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const url = env === "production" ? "https://www.zillow.com/graphql" : "https://www.qa.zillow.net/graphql";
    (async () => {
      var _a;
      const query = `
			query {
				viewer {
					firstName
					lastName
                    email
                    profile {
                      cellNumber
                    }
                }
			}
			`;
      const urlWithQuery = `${url}?query=${encodeURIComponent(query)}`;
      const headers = {
        "Content-Type": "application/json",
        "x-z-enable-oauth-conversion": "true"
      };
      if (process.env.LOGIN_MEMENTO) {
        headers["x-z-login-memento"] = process.env.LOGIN_MEMENTO;
      }
      try {
        const response = await fetch(urlWithQuery, {
          method: "GET",
          headers
        }).then((res) => res.json()).catch(() => null);
        setUser(((_a = response == null ? void 0 : response.data) == null ? void 0 : _a.viewer) || false);
        setLoading(false);
      } catch (error) {
        setUser(false);
        setLoading(false);
        console.error(error);
      }
    })();
  }, [env]);
  return {
    data: {
      user
    },
    loading
  };
};
export {
  useCurrentUser
};
